export const ISSUES_FOR_TAPPING_REQUEST = "ISSUES_FOR_TAPPING_REQUEST";
export const ISSUES_FOR_TAPPING_SUCCESS = "ISSUES_FOR_TAPPING_SUCCESS";
export const ISSUES_FOR_TAPPING_FAILED = "ISSUES_FOR_TAPPING_FAILED";